import { resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/virtualredtag/red-tag-38.svg'


const _withScopeId = n => (_pushScopeId("data-v-4b342b78"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "trailer-graphic trailer-graphic-company"
}
const _hoisted_2 = {
  key: 1,
  class: "trailer-graphic"
}
const _hoisted_3 = {
  key: 2,
  src: _imports_0,
  alt: "",
  class: "trailer-graphic-badge"
}
const _hoisted_4 = {
  key: 3,
  class: "trailer-graphic-overlay trailer-graphic-logo"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SvgTrailerShell = _resolveComponent("SvgTrailerShell")!
  const _component_SvgProhibitedBadge = _resolveComponent("SvgProhibitedBadge")!
  const _component_SvgVerifiedBadge = _resolveComponent("SvgVerifiedBadge")!
  const _component_CompanyLogo = _resolveComponent("CompanyLogo")!

  return (_ctx.companyIllustration)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.companyIllustration), { class: "trailer-graphic-company-illustration" }))
      ]))
    : (_openBlock(), _createElementBlock("div", _hoisted_2, [
        _createVNode(_component_SvgTrailerShell, {
          color: _ctx.shellColor,
          class: "trailer-graphic-shell"
        }, null, 8, ["color"]),
        (_ctx.state === _ctx.GraphicState.blocked)
          ? (_openBlock(), _createBlock(_component_SvgProhibitedBadge, {
              key: 0,
              class: "trailer-graphic-overlay"
            }))
          : (_ctx.state === _ctx.GraphicState.success)
            ? (_openBlock(), _createBlock(_component_SvgVerifiedBadge, {
                key: 1,
                class: "trailer-graphic-overlay"
              }))
            : (_ctx.state === _ctx.GraphicState.redTagged)
              ? (_openBlock(), _createElementBlock("img", _hoisted_3))
              : (_openBlock(), _createElementBlock("div", _hoisted_4, [
                  _createVNode(_component_CompanyLogo, {
                    company: _ctx.company ?? null
                  }, null, 8, ["company"])
                ]))
      ]))
}